import { Page } from '~shared-components/utils/enums'

const defaultState = 'Brenntag Connect'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (state = defaultState, action: any) => {
  switch (action.type) {
    case Page.NotFound:
      return 'Page not found error (404)'
    case Page.AccessRestricted:
      return 'Access denied | Brenntag Connect'
    case Page.Orders:
      return 'Orders | Brenntag Connect'
    case Page.OrderDetails:
      return `Order details | Brenntag Connect` // Title is updated with more details in OrderDetails.tsx
    case Page.Cart:
      return 'Shopping cart | Brenntag Connect'
    case Page.Products:
      return 'Products | Brenntag Connect'
    case Page.ProductDetails:
      return 'Product | Brenntag Connect' // Title is updated with more details in ProductDetails.tsx
    case Page.TermsAndConditions:
      return 'Terms and Conditions | Brenntag Connect' // Title is set for terms of use in TermsAndConditions.tsx
    case Page.OrderConfirmation:
      return 'Order submitted | Brenntag Connect'
    case Page.Invoices:
      return 'Invoices | Brenntag Connect'
    case Page.Profile:
      return 'My Profile | Brenntag Connect'
    case Page.PaymentInvoice:
    case Page.PaymentInvoiceRedirect:
      return 'Payment | Brenntag Connect'
    case Page.Quotes:
      return 'Quotes | Brenntag Connect'
    case Page.QuoteDetails:
      return 'Quote details | Brenntag Connect'
    default:
      return state
  }
}
